import React from 'react';


export default function Contact() {
    return (
        <div className='section-container'>
            <div><p>Para cuestiones musicales, referirse a @lautarodelfuturo en IG </p></div>
        </div>
    )
}